export default {
    baseStyle: {
        text: {
            color: 'red.550',
            fontSize: '12px',
            marginTop: '0px',
            fontWeight: '400'
        }
    }
}
